import type { TConstraints, TOptionalConstraint } from '@feathr/rachis';

import { MailrailBaseEmailCampaign } from './mailrail_email_base';
import { monetizationConstraints } from './monetization';
import type { IMailrailSingleSendEmailCampaign } from './types';

export class MailrailSingleSendEmailCampaign extends MailrailBaseEmailCampaign<IMailrailSingleSendEmailCampaign> {
  public override get constraints(): TConstraints<IMailrailSingleSendEmailCampaign> {
    return {
      ...super.constraints,
      monetization_value: (): TOptionalConstraint => {
        if (this.isMonetization) {
          return monetizationConstraints.monetization_value;
        }
        return undefined;
      },
      // Single Sends run all at once, so no end date is needed
      date_end: undefined,
      segments_included: {
        length: {
          minimum: 1,
          tooShort: '^Add at least one included group',
        },
        list: {
          presence: {
            allowEmpty: false,
            message: '^Finish selecting a group or remove the placeholder group.',
          },
        },
        duplicates: {
          maximum: 0,
          message: '^Groups must be unique.',
        },
      },
    };
  }
}
